/*
 * Props.
 */

import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {computeJobProgress} from '../../../../../../../../../src/helpers/jobHelpers';
import {makeMapStateToProps, ResolveStateProps} from '../../../../../../../../../src/helpers/reselectHelpers';
import {CrmSyncSourcesEnum} from '../../../../../../../../../src/models/api/crmSyncModel';
import {makeGetAccountCrmSyncViaSource} from '../../../../../../../../../src/store/data/crmSync/crmSyncSelectors';
import {getAllRunningSyncAccountsJobs} from '../../../../../../../../../src/store/data/jobs/jobsSelectors';
import {Handler} from '../../../../../../../../shared/helpers/src/react/reactHelpers';
import {CrmSyncsScheduleInfoBox} from './crmSyncsScheduleInfoBox';

export interface CrmSyncsScheduleInfoBoxPublicProps {
  source: CrmSyncSourcesEnum;
  showNextSync: boolean;
  canSyncNow: boolean;
  onSync: Handler;
}

type CrmSyncsScheduleInfoBoxContainerStateProps = ResolveStateProps<typeof mapStateToProps>;
export type CrmSyncsScheduleInfoBoxContainerProps = CrmSyncsScheduleInfoBoxPublicProps &
  CrmSyncsScheduleInfoBoxContainerStateProps;

/*
 * Selectors.
 */
// TODO: PB-38542 Update to include contacts last synced at
function makeGetLastSyncedAtViaSource() {
  return createSelector([makeGetAccountCrmSyncViaSource()], (accountCrmSync) => accountCrmSync?.lastSyncedAt);
}

function makeGetActiveSyncJobProgressPercentageViaSource() {
  return createSelector(
    [makeGetAccountCrmSyncViaSource(), getAllRunningSyncAccountsJobs],
    (accountCrmSync, jobs) => {
      if (!accountCrmSync || jobs.length === 0) {
        return undefined;
      }

      const activeJob = jobs.find((job) => job.sync_id === accountCrmSync.id);
      if (!activeJob) {
        return undefined;
      }

      const jobProgress = computeJobProgress(activeJob);
      if (jobProgress === 1) {
        // don't return progress when it's completed
        return undefined;
      }
      // we want the percentage and computeJobProgress returns a decimal
      return Math.floor(100 * jobProgress);
    },
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CrmSyncsScheduleInfoBoxPublicProps>()(() => ({
  lastSyncedAt: makeGetLastSyncedAtViaSource(),
  jobProgressPercentage: makeGetActiveSyncJobProgressPercentageViaSource(),
}));

export const CrmSyncsScheduleInfoBoxContainer = connect(mapStateToProps)(CrmSyncsScheduleInfoBox);
